const breadcrumb = {
  init: function () {
    document.querySelectorAll('.breadcrumbs__back').forEach(button => {
      button.addEventListener('click', () => {
        window.history.back();
      });
    });
  }
};

breadcrumb.initialize = () => {
  breadcrumb.init();
};

module.exports = breadcrumb;
